import { render, staticRenderFns } from "./DevelopmentPageSecond.vue?vue&type=template&id=379f1ade&scoped=true"
import script from "./DevelopmentPageSecond.vue?vue&type=script&lang=js"
export * from "./DevelopmentPageSecond.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentPageSecond.vue?vue&type=style&index=0&id=379f1ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f1ade",
  null
  
)

export default component.exports